<template>
  <!-- bg_white bg_gray  -->
  <div v-show="showTit === '股本股东'">
    <p
      class="nothing-tips"
      v-if="
        affairQuery &&
        modleDataShow &&
        !structureData &&
        !gbgdData &&
        !cgbdData &&
        !zygdData &&
        !gbjgData
      "
    >
      暂无数据
    </p>
    <section class="main">
      <!-- 股本结构 -->
      <hgroup class="mainPage gdhs bdgb" v-if="gbjgData">
        <header>股本结构</header>
        <div class="gbgd-item">
          <div class="shadow-block gbgd-float-tip flex">
            <dl>
              <dt class="legend-org">总股本(股)</dt>
              <dd>{{ process(gbjgData.zgb) }}</dd>
            </dl>
            <dl>
              <dt>流通股(股)</dt>
              <dd>{{ process(gbjgData.ltg) }}</dd>
            </dl>
            <dl>
              <dt class="legend-red">H股股本(股)</dt>
              <dd>{{ process(gbjgData.hggb) }}</dd>
            </dl>
          </div>
          <div class="gbgd-progress-bar">
            <div class="gbgd-bar-tit fl">
              {{ gbjgData.hgzzgb }}%<small>H股占总股本</small>
            </div>
            <!-- <div class="gbgd-bar-tit fr">
              10.00%
              <small>流通股占总股本</small>
            </div> -->
            <div class="gbgd-bar-block">
              <span :style="{ width: gbjgData.hgzzgb + '%' }"></span>
            </div>
          </div>
        </div>
      </hgroup>
      <!-- 主要股东 -->
      <hgroup class="mainPage gdhs bdgb" v-if="zygdData">
        <header>
          主要股东
          <!-- <div :class="zyguShowBtn ? 'btn_show' : 'showNot'" @click="zyguShowBtn = !zyguShowBtn">最终控制人</div>  -->
          <a @click="goLinkMore">更多</a>
        </header>
        <div class="tab-sub-cont">
          <div class="nav-line flex">
            <span
              v-for="(item, index) in zygdData.jzrqList"
              :class="zygdNavKey === index ? 'cur' : ''"
              :key="index"
              @click="zygdNavKey = index"
              >{{ item | timeFream }}</span
            >
          </div>
          <div class="nav-line-content">
            <table class="table table-col4" width="100%">
              <div class="tr_box">
                <tr>
                  <th>股东名称</th>
                  <th>持股占比</th>
                  <th>持股股数/变动</th>
                </tr>
              </div>
              <div
                class="tr_box"
                v-for="(item, index) in zygdData.data[zygdData.jzrqList[zygdNavKey]]"
                :key="index"
              >
                <tr>
                  <td>{{ item.gdmc }}</td>
                  <td>{{ item.cgzb ? item.cgzb + "%" : item.cgzb }}</td>
                  <td>
                    {{ process(item.cggs) }} /
                    <span :class="item.cgzbbd | zygdColor">{{
                      item.cgzbbd | zygdFilter
                    }}</span>
                  </td>
                </tr>
                <!-- <div v-show="zyguShowBtn" class="final_box">数据库恢复健康sad混分巨兽款到发货时刻绝代风华涉及到开发和圣诞节开放</div> -->
              </div>
            </table>
          </div>
        </div>
      </hgroup>
      <!-- 股本变动 -->
      <hgroup class="mainPage gbbd" v-if="gbbdData">
        <header>股本变动<a a href="JavaScript:;" @click="goGbbdMore">更多</a></header>
        <div class="m-table-block">
          <table class="m-table-four">
            <tr>
              <th><span>公告日期</span></th>
              <th><span>港股普通股</span></th>
              <th><span>变动原因</span></th>
            </tr>
            <tr v-for="(item, index) in gbbdData" :key="index">
              <td>{{ item.fbrq }}</td>
              <td>{{ process(item.gbsl) }}</td>
              <!--  :class="item.bdyy | textColor" -->
              <td>
                <span>{{ item.bdyybz }}</span>
              </td>
            </tr>
          </table>
        </div>
      </hgroup>
      <!-- 持股变动 -->
      <hgroup class="mainPage cgbd" v-if="cgbdData">
        <header>持股变动<a :href="cgbdData.moreUrl">更多</a></header>
        <div class="m-table-block">
          <table class="m-table-four">
            <tr>
              <th><span>日期</span></th>
              <th><span>股东名称</span></th>
              <th><span>变动股数</span></th>
              <th><span>变动后持股</span></th>
            </tr>
            <tr v-for="(item, index) in cgbdData.cgbdList" :key="index">
              <td>{{ item.BGQ }}</td>
              <td>{{ item.SHHOLDERNAME }}</td>
              <td :class="item.BDFX | textColor">
                <span>{{ item.SJGF }}</span>
              </td>
              <td>
                <span>{{ item.BDHSL }}</span>
              </td>
            </tr>
          </table>
        </div>
      </hgroup>

      <!-- 、港股回购 -->
      <hgroup class="mainPage" v-if="repoData && repoData.gbhgList.length > 0">
        <header>
          港股回购<span>币种：{{ repoData.REPCUR }}</span
          ><a :href="repoData.hg_moreUrl">更多</a>
        </header>
        <div class="m-block">
          <table class="m-table-two m-table-hk m-table-col3" border="0" width="100%">
            <tr>
              <th>登记日</th>
              <th>回购金额</th>
              <th>占总股本比例</th>
            </tr>
            <tr v-for="(item, index) in repoData.gbhgList" :key="index">
              <td>{{ item.REPDATE_S }}</td>
              <td>{{ item.REPTOTPRICE }}</td>
              <td>{{ item.REPSHARENUM_P }}%</td>
            </tr>
          </table>
        </div>
      </hgroup>
      <!-- 拆股合股 -->
      <hgroup class="mainPage cghg" v-if="repoData && repoData.hbcxList.length > 0">
        <header>拆股合股<a :href="repoData.hbcx_moreUrl">更多</a></header>
        <div class="m-block">
          <table class="m-table-two m-table-hk m-table-col3" border="0" width="100%">
            <tr>
              <th>生效日</th>
              <th>类型</th>
              <th>拆合比例</th>
            </tr>
            <tbody v-for="(item, index) in repoData.hbcxList" :key="index">
              <tr>
                <td>{{ item.EFFECTDATE_S }}</td>
                <td>{{ item.CHLX }}</td>
                <td>{{ item.CHBL }}</td>
              </tr>
              <tr>
                <td colspan="3" class="td-colspan">
                  <span class="fl case-tit">方案说明：</span>
                  <div
                    :class="
                      unwindId.indexOf(index) !== -1 ? 'case-info' : 'case-info folder'
                    "
                  >
                    {{ item.FASM }}
                  </div>
                  <span
                    class="folder-more"
                    v-show="item.FASM.length > 48"
                    @click="unwind(index)"
                    >{{ unwindId.indexOf(index) !== -1 ? "收起" : "展开" }}</span
                  >
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </hgroup>
    </section>
    <Loading v-if="!affairQuery && !modleDataShow"></Loading>
    <Declare
      v-if="
        affairQuery &&
        modleDataShow &&
        (structureData || gbgdData || cgbdData || zygdData || gbjgData)
      "
    ></Declare>
  </div>
</template>

<script>
import { getEventData } from "../api/index";
import mixins from "../mixins/index";
import Loading from "../components/loading";
import Declare from "../components/declare";
export default {
  name: "shareholder",
  props: ["showTit", "token"],
  data() {
    return {
      notData: false,
      structureData: null,
      gbgdData: null,
      cgbdData: null,
      repoData: null, //回购以及拆股合股
      gbbdData: null, //股本变动数据
      zygdData: null, //主要股东数据
      gbjgData: null, //股本结构

      zygdNavKey: 0, //nav当前选中ID
      affairQuery: false,
      modleDataShow: false,
      zyguShowBtn: false,
      unwindId: [],
    };
  },
  components: { Loading, Declare },
  mixins: [mixins],
  filters: {
    freamColor: function (num) {
      if (num === 0) {
        return "";
      } else if (num < 0) {
        return "green";
      } else if (num > 0) {
        return "red";
      }
    },
    textColor: function (text) {
      if (text === "减仓") {
        return "green";
      } else if (text === "增仓") {
        return "red";
      } else {
        return "";
      }
    },
  },
  watch: {
    showTit: {
      handler(newval, old) {
        if (newval === "股本股东" && !this.affairQuery) {
          this.code = this.getUrlQuery("code");
          this.$nextTick(() => {
            this.getAffairData();
            this.getModleData();
          });
        }
      },
      immediate: true,
    },
  },
  methods: {
    unwind: function (id) {
      if (this.unwindId.indexOf(id) === -1) {
        this.unwindId.push(id);
      } else {
        var index = this.unwindId.indexOf(id);
        this.unwindId.splice(index, 1);
      }
    },
    // 获取事件提醒数据
    getAffairData: function () {
      let that = this;
      let structure = that.code + "-B4-1"; // 流通股本 总股本
      let gbgdKey = that.code + "-B3"; // 股本股东列表
      let cgbdKey = that.code + "-B3-cgbd-1"; // 持股变动
      let gbbdKey = "mapdata/gbgd/gbbd/" + that.code; //股本变动
      let zygdKey = "mapdata/gbgd/zygd/" + that.code; // 主要股东数据
      let busiTypeArr = [zygdKey, structure, gbgdKey, cgbdKey, gbbdKey];
      let objs = {
        busiCode: window.config.busiCode,
        merId: window.config.merId,
        reqData: {
          busiType: busiTypeArr.join(),
          category: "hkf10",
        },
      };
      getEventData(JSON.stringify(objs), that.token)
        .then((res) => {
          that.affairQuery = true;
          if (res.resCode === "000000") {
            that.zygdData = res.resData.hasOwnProperty(zygdKey)
              ? res.resData[zygdKey]
              : null;
            that.structureData = res.resData.hasOwnProperty(structure)
              ? res.resData[structure]
              : null;
            that.gbgdData = res.resData.hasOwnProperty(gbgdKey)
              ? res.resData[gbgdKey]
              : null;
            that.cgbdData = res.resData.hasOwnProperty(cgbdKey)
              ? res.resData[cgbdKey]
              : null;
            that.gbbdData =
              res.resData.hasOwnProperty(gbbdKey) && res.resData[gbbdKey].dataList.length
                ? res.resData[gbbdKey].dataList
                : null;
          }
        })
        .catch(() => {
          that.affairQuery = true;
        });
    },
    getModleData: function () {
      let that = this;
      let repo = that.code + "-B4-2"; // 回购以及拆股合股
      let gbjgKey = "mapdata/gbgd/gbjg/" + that.code; //股本结构
      let busiTypeArr = [repo, gbjgKey];
      let objs = {
        busiCode: window.config.busiCode,
        merId: window.config.merId,
        reqData: {
          busiType: busiTypeArr.join(),
          category: "hkf10",
        },
      };
      getEventData(JSON.stringify(objs), that.token)
        .then((res) => {
          that.modleDataShow = true;
          if (res.resCode === "000000") {
            that.repoData = res.resData.hasOwnProperty(repo) ? res.resData[repo] : null;
            that.gbjgData = res.resData.hasOwnProperty(gbjgKey)
              ? that.checkGbjgData(res.resData[gbjgKey])
              : null;
          }
        })
        .catch(() => {
          that.modleDataShow = true;
        });
    },
    // 点击主要股东更多
    goLinkMore: function () {
      window.location.href =
        window.location.protocol +
        "//" +
        window.location.host +
        "/zygd_more?&code=" +
        this.code +
        "&DZHSPECIAL=1&themeStyleVs=" +
        this.getUrlQuery("themeStyleVs");
    },
    // 点击跳转股本变动更多页面
    goGbbdMore: function () {
      window.location.href =
        window.location.protocol +
        "//" +
        window.location.host +
        "/gbbd_more?&code=" +
        this.code +
        "&DZHSPECIAL=1&themeStyleVs=" +
        this.getUrlQuery("themeStyleVs");
    },
  },
};
</script>
<style lang="less" scoped></style>
